import { useEffect } from 'react';

import Box from 'shopper/components/Box';

import Layout from 'components/Layout';
import HeadWithNoIndexAndNoFollow from 'components/Seo/HeadWithNoIndexAndNoFollow';
import TabNav from 'components/SuggestNewItem/TabNav';

import { sendEvent } from 'lib/gtag';

import NewThreadForm from './Form';
import Heading from './Heading';
import Sidebar from './Sidebar';

const GA_EVENT_CATEGORY = 'suggest_topic';

const NewThreadPage = () => {
  useEffect(() => {
    sendEvent({
      category: GA_EVENT_CATEGORY,
      action: 'load_page',
    });
  }, []);

  return (
    <>
      <HeadWithNoIndexAndNoFollow />
      <Layout
        headingComponent={<Heading />}
        sidebarComponent={<Sidebar gaEventCategory={GA_EVENT_CATEGORY} />}
        maxWidthOnMobileDevices
      >
        <Box className="mb-14">
          <TabNav gaEventCategory={GA_EVENT_CATEGORY} />
          <NewThreadForm gaEventCategory={GA_EVENT_CATEGORY} />
        </Box>
      </Layout>
    </>
  );
};

export default NewThreadPage;
